module.exports = __webpack_public_path__ + "static/media/ava.37d15037.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/ava.jpg
// module id = 308
// module chunks = 0